import { render } from "./HookSection.vue?vue&type=template&id=879e0592&scoped=true"
import script from "./HookSection.vue?vue&type=script&lang=js"
export * from "./HookSection.vue?vue&type=script&lang=js"

import "./HookSection.vue?vue&type=style&index=0&id=879e0592&scoped=true&lang=css"

import exportComponent from "/Users/bellakwon/Desktop/thesis01/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-879e0592"]])

export default __exports__